document.addEventListener('DOMContentLoaded', function (event) {
    const variantSelect = document.querySelector("input[name='id']")
    variantSelect.addEventListener('change', function(e){
        document.querySelector('.man-product-variant-title').innerHTML = getVariantById(e.target.value)
        document.querySelector('.man-product-variant-price').innerHTML = variantPrices[e.target.value]
    })   
})

function getVariantById(variantId){
    const item = productVariants.find(e => e.id == variantId)
    return item.title
}